
const defaultPriceFormat = (value) => {
	return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}

export {
	defaultPriceFormat
}
